









import { Component, Vue, Prop } from "vue-property-decorator";
@Component({
    filters:{
        trim(name:string){
            return name.trim()
        }
    }
})
export default class Navigator extends Vue{
    @Prop({default:() => []})
    routeList:any

    routeTo(item:any){
        if(!item.isCurrent && item.url)
            this.$router.push(item.url)
        else if(!item.isCurrent && item.routeName)
            this.$router.push({
                name: item.routeName,
                params: item.params,
                query: item.query
            })
    }
}
